import React, { Suspense, lazy } from "react";
import { Link } from "react-router-dom";
import { Box, Loader2 } from "lucide-react";
import { DEMO_ISO } from "@/lib/demoIso";
import { useLang } from "@/context/LangContext";
import { PV_TR } from "@/lib/pipeVizI18n";

const Pipe3D = lazy(() => import("@/components/Pipe3D"));

export const HeroIsoDemo = ({ caption, cta, to }) => {
  const { lang } = useLang();
  return (
  <div className="mt-8 max-w-xl" data-testid="hero-iso-demo">
    <div className="relative border border-gold-700/50 bg-zinc-950 aspect-[4/3] overflow-hidden shadow-[0_20px_60px_-20px_rgba(212,175,55,0.35)]">
      <Suspense fallback={<div className="w-full h-full flex items-center justify-center"><Loader2 className="w-8 h-8 animate-spin text-gold-400" /></div>}>
        <Pipe3D segments={DEMO_ISO.segments} diameter={DEMO_ISO.pipe_diameter} fittings={DEMO_ISO.fittings} autoRotate />
      </Suspense>
      <span className="absolute top-3 left-3 wb-tag !bg-black/70 !border-gold-600 !text-gold-300 inline-flex items-center gap-1 pointer-events-none">
        <Box className="w-3 h-3" /> {(PV_TR[lang] || PV_TR.sk).nav} · 3D
      </span>
    </div>
    <div className="mt-3 flex flex-wrap items-center justify-between gap-2">
      <span className="text-xs text-zinc-500" data-testid="hero-iso-demo-caption">{caption}</span>
      <Link to={to} data-testid="hero-iso-demo-cta" className="text-xs font-bold uppercase tracking-wider text-gold-400 hover:text-gold-200 transition-colors">{cta}</Link>
    </div>
  </div>
);
};
